var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "verify-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            width: "600px",
            title: "用户认证",
            "z-index": "999999"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose
          }
        },
        [
          _c(
            "div",
            { staticClass: "verify-type" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeTab,
                    callback: function($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "企业认证", name: "company" } },
                    [
                      _c(
                        "div",
                        { staticClass: "verify-form" },
                        [
                          _c("p", { staticClass: "verify-tip" }, [
                            _vm._v("请上传企业营业执照或对公付款单图片")
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form",
                            {
                              ref: "companyForm",
                              attrs: {
                                model: _vm.companyForm,
                                "label-width": "120px"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "公司全称", required: "" } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入公司全称" },
                                    model: {
                                      value: _vm.companyForm.company_name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.companyForm,
                                          "company_name",
                                          $$v
                                        )
                                      },
                                      expression: "companyForm.company_name"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "营业执照/对公付款单",
                                    required: ""
                                  }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "upload-demo",
                                      attrs: {
                                        action:
                                          "https://api.kol.cn/api/ueditor?action=uploadimage",
                                        "on-change":
                                          _vm.handleCompanyFileChange,
                                        "on-remove":
                                          _vm.handleCompanyFileRemove,
                                        "before-upload": _vm.handleBeforeUpload,
                                        "file-list": _vm.companyFileList,
                                        limit: 1,
                                        accept: "image/*",
                                        "with-credentials": true,
                                        name: "upfile",
                                        "auto-upload": false
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary"
                                          }
                                        },
                                        [_vm._v("点击上传")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip"
                                        },
                                        [
                                          _vm._v(
                                            "只能上传 jpg/png 文件，且不超过 3MB"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.companyImageUrl
                                    ? _c(
                                        "div",
                                        { staticClass: "image-preview" },
                                        [
                                          _c("img", {
                                            staticClass: "preview-img",
                                            attrs: {
                                              src: _vm.companyImageUrl,
                                              alt: "营业执照预览"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "preview-actions" },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.previewImage(
                                                        _vm.companyImageUrl
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-zoom-in"
                                                  }),
                                                  _vm._v(
                                                    " 查看大图\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.removeCompanyImage
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-delete"
                                                  }),
                                                  _vm._v(
                                                    " 删除\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "个人认证", name: "personal" } },
                    [
                      _c(
                        "div",
                        { staticClass: "verify-form" },
                        [
                          _c("p", { staticClass: "verify-tip" }, [
                            _vm._v("请上传身份证正反面照片")
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form",
                            {
                              ref: "personalForm",
                              attrs: {
                                model: _vm.personalForm,
                                "label-width": "120px"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "姓名", required: "" } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入姓名" },
                                    model: {
                                      value: _vm.personalForm.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.personalForm, "name", $$v)
                                      },
                                      expression: "personalForm.name"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "身份证号码", required: "" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入身份证号码" },
                                    model: {
                                      value: _vm.personalForm.id_card,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.personalForm,
                                          "id_card",
                                          $$v
                                        )
                                      },
                                      expression: "personalForm.id_card"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "身份证正面", required: "" }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "upload-demo",
                                      attrs: {
                                        action:
                                          "https://api.kol.cn/api/ueditor?action=uploadimage",
                                        "on-change": _vm.handleFrontFileChange,
                                        "on-remove": _vm.handleFrontFileRemove,
                                        "before-upload": _vm.handleBeforeUpload,
                                        "file-list": _vm.frontFileList,
                                        limit: 1,
                                        accept: "image/*",
                                        "with-credentials": true,
                                        name: "upfile",
                                        "auto-upload": false
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary"
                                          }
                                        },
                                        [_vm._v("点击上传")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip"
                                        },
                                        [
                                          _vm._v(
                                            "只能上传 jpg/png 文件，且不超过 3MB"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.frontImageUrl
                                    ? _c(
                                        "div",
                                        { staticClass: "image-preview" },
                                        [
                                          _c("img", {
                                            staticClass: "preview-img",
                                            attrs: {
                                              src: _vm.frontImageUrl,
                                              alt: "身份证正面预览"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "preview-actions" },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.previewImage(
                                                        _vm.frontImageUrl
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-zoom-in"
                                                  }),
                                                  _vm._v(
                                                    " 查看大图\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: _vm.removeFrontImage
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-delete"
                                                  }),
                                                  _vm._v(
                                                    " 删除\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "身份证反面", required: "" }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "upload-demo",
                                      attrs: {
                                        action:
                                          "https://api.kol.cn/api/ueditor?action=uploadimage",
                                        "on-change": _vm.handleBackFileChange,
                                        "on-remove": _vm.handleBackFileRemove,
                                        "before-upload": _vm.handleBeforeUpload,
                                        "file-list": _vm.backFileList,
                                        limit: 1,
                                        accept: "image/*",
                                        "with-credentials": true,
                                        name: "upfile",
                                        "auto-upload": false
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary"
                                          }
                                        },
                                        [_vm._v("点击上传")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip"
                                        },
                                        [
                                          _vm._v(
                                            "只能上传 jpg/png 文件，且不超过 3MB"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.backImageUrl
                                    ? _c(
                                        "div",
                                        { staticClass: "image-preview" },
                                        [
                                          _c("img", {
                                            staticClass: "preview-img",
                                            attrs: {
                                              src: _vm.backImageUrl,
                                              alt: "身份证反面预览"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "preview-actions" },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.previewImage(
                                                        _vm.backImageUrl
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-zoom-in"
                                                  }),
                                                  _vm._v(
                                                    " 查看大图\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: _vm.removeBackImage
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-delete"
                                                  }),
                                                  _vm._v(
                                                    " 删除\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: { click: _vm.handleSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-591950aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-591950aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/UserVerify.vue
// module id = null
// module chunks = 